<div class="wrap">
    <img [src]="imageBase64">
</div>